import { render } from "./Allprograms.vue?vue&type=template&id=7e0a98b4&scoped=true"
import script from "./Allprograms.vue?vue&type=script&lang=js"
export * from "./Allprograms.vue?vue&type=script&lang=js"

import "./Allprograms.vue?vue&type=style&index=0&id=7e0a98b4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7e0a98b4"

export default script